import { render, staticRenderFns } from "./typeManage.vue?vue&type=template&id=773cee39&"
import script from "./typeManage.vue?vue&type=script&lang=js&"
export * from "./typeManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports